import { render, staticRenderFns } from "./EditFormDialog.vue?vue&type=template&id=5642b1fc"
import script from "./EditFormDialog.vue?vue&type=script&lang=js"
export * from "./EditFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports